module.exports = __webpack_public_path__ + "img/sankaku_29_red.bf85862c.png";